/**
 * One short tick, for a success that followed a deliberate press.
 *
 * Never for navigation, never for a tab press, never for every toast — a
 * phone that buzzes at everything is a phone people mute. No-op wherever the
 * Vibration API is absent, which is all of iOS, and wherever a policy blocks
 * it (the call itself can throw there).
 */
export function tapHaptic(pattern: number | readonly number[] = 10): void {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  try {
    navigator.vibrate(pattern as number | number[]);
  } catch {
    /* blocked by policy — silence is the right outcome */
  }
}
